import { render } from "./BeatsLogs.vue?vue&type=template&id=5fd748f7"
import script from "./BeatsLogs.vue?vue&type=script&lang=js"
export * from "./BeatsLogs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__